const MuiListItem = {
  root: {
    '.OriSelectList>&:hover': {
      fontWeight: 'bold'
    },
    '.OriSelectList>&$selected': {
      position: 'relative',
      fontWeight: 'bold',
      backgroundColor: 'unset'
    },
    '.OriSelectList>&$selected:before': {
      position: 'absolute',
      left: 0,
      borderRight: '3px solid currentColor',
      borderRadius: '0 2px 2px 0',
      height: '100%',
      content: '""'
    }
  }
};
export default MuiListItem;